import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import TransitionsModal from '../../component/TransitionsModal';

const EvaluateServiceRequest = ({ evaluation, srToEvaluation, handleCloseEvaluation, handleSaveEvaluation }) => {

    const satisfaction = [
        {id: '1', label: 'Ótimo'},
        {id: '2', label: 'Bom'},
        {id: '3', label: 'Satisfatório'},
        {id: '5', label: 'Ruim'},
    ]

    const initialValues = {
        levelDeadline: '',
        deadlineSatisfaction: '',
        levelQuality: '',
        qualitySatisfaction: '',
    };

    const researchSchema = Yup.object().shape({
        deadlineSatisfaction: Yup.string()
          .required('Obrigatório'),
        qualitySatisfaction: Yup.string()
          .required('Obrigatório'),
    });

    const handleSubmit = (form) => {
        handleSaveEvaluation({
            number: srToEvaluation.number,
            levelDeadline: form.levelDeadline.id,
            deadlineSatisfaction : form.deadlineSatisfaction,
            levelQuality: form.levelQuality.id,
            qualitySatisfaction: form.qualitySatisfaction,
        });
    };

    return(

        <TransitionsModal
            title={`Pesquisa de Satisfação\\Qualidade`}
            open={evaluation}
        >

            <Box sx={{bgcolor: 'background.paper'}}>

                <Formik
                    validationSchema={researchSchema}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validateOnMount
                    >

                        {({
                            values,
                            isValid,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue
                        }) => (
                            
                            <FormControl fullWidth sx={{padding: 1}}>

                                <Grid container sx={{border: 1, padding: 0.5, mb: 1, borderRadius: 1, borderColor: 'primary.card'}} spacing={1}>
                                    <Grid item xs={12} sm={12}>{`SS: ${srToEvaluation.number}`}</Grid>
                                    <Grid item xs={12} sm={12}>{`Dt Abertura: ${srToEvaluation.openingDate}`}</Grid>
                                    <Grid item xs={12} sm={12}>{`Serviço: ${srToEvaluation.serviceType}`}</Grid>
                                    <Grid item xs={12} sm={12}>{`Bem: ${srToEvaluation.asset}`}</Grid>
                                    <Grid item xs={12} sm={4}>{`Dt Fechamento: ${srToEvaluation.closingDate}`}</Grid>
                                    <Grid item xs={12} sm={4}>{`Hr Fechamento: ${srToEvaluation.closingTime}`}</Grid>
                                    <Grid item xs={12} sm={4}>{`Duração: ${srToEvaluation.duration}`}</Grid>
                                </Grid>

                                <Grid container sx={{border: 1, padding: 0.5, mb: 1, borderRadius: 1, borderColor: 'primary.card'}} spacing={1}>
                                    <Grid item xs={12} sm={12}>{`Solicitação:`}</Grid>
                                    <Grid item xs={12} sm={12}>{`${srToEvaluation.request}`}</Grid>
                                </Grid>

                                <Grid container sx={{border: 1, padding: 0.5, mb: 1, borderRadius: 1, borderColor: 'primary.card'}} spacing={1}>
                                    <Grid item xs={12} sm={12}>{`Solução:`}</Grid>
                                    <Grid item xs={12} sm={12}>{`${srToEvaluation.solution}`}</Grid>
                                </Grid>

                        

                                <Grid container sx={{border: 1, padding: 0.5, mb: 1, borderRadius: 1, borderColor: 'primary.card'}} spacing={1}>

                                    <Grid item xs={12} sm={12}>
                                        <Typography sx={{bgcolor: 'background.main', padding: 1, borderRadius: 1}}>
                                            Atendimento no Prazo?
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>

                                        <Autocomplete
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            noOptionsText='Não localizado'
                                            id='levelDeadline'
                                            name='levelDeadline'
                                            disablePortal
                                            options={satisfaction}
                                            onChange={(e, newValue) => {
                                                setFieldValue('levelDeadline',
                                                newValue !== null ? newValue : values.levelDeadline
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    margin='dense'
                                                    label='Satisfação com o prazo'
                                                    fullWidth
                                                    name='levelDeadline'
                                                    {...params}
                                                />
                                            )}
                                        />

                                    </Grid>

                                    <Grid item xs={12} sm={12}>

                                        <TextField
                                            id='deadlineSatisfaction'
                                            name='deadlineSatisfaction'
                                            label='Atendimento no prazo'
                                            multiline
                                            minRows={6}
                                            maxRows={6}
                                            fullWidth
                                            placeholder='Descreva a satisfação com prazo'
                                            value={values.deadlineSatisfaction}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />

                                    </Grid>

                                </Grid>

                                
                                <Grid container sx={{border: 1, padding: 0.5, mb: 1, borderRadius: 1, borderColor: 'primary.card'}} spacing={1}>
                                    
                                    <Grid item xs={12} sm={12}>
                                        <Typography sx={{bgcolor: 'background.main', padding: 1, borderRadius: 1}}>
                                            Atendimento da Necessidade?
                                        </Typography>
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={12}>
                                        <Autocomplete
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            noOptionsText='Não localizado'
                                            id='levelQuality'
                                            name='levelQuality'
                                            disablePortal
                                            options={satisfaction}
                                            onChange={(e, newValue) => {
                                                setFieldValue('levelQuality',
                                                newValue !== null ? newValue : values.levelQuality
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    margin='dense'
                                                    label='Satisfação com a execução'
                                                    fullWidth
                                                    name='levelQuality'
                                                    {...params}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={12}>
                                        <TextField
                                            id='qualitySatisfaction'
                                            name='qualitySatisfaction'
                                            label='Atendimento da necessidade'
                                            multiline
                                            minRows={6}
                                            maxRows={6}
                                            fullWidth
                                            placeholder='Descreva a satisfação com atendimento'
                                            value={values.qualitySatisfaction}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Grid>
             
                                </Grid>

                                <ButtonGroup 
                                    sx={{display: 'flex', width: '100%', justifyContent: 'flex-end', mt: 1}}
                                    disableElevation
                                >

                                    <Button variant='contained' color='error' onClick={handleCloseEvaluation} disabled={isSubmitting}>
                                        Cancelar
                                    </Button>

                                    <Button variant='contained' color='primary' onClick={handleSubmit} disabled={isSubmitting || !isValid}>
                                        Enviar
                                    </Button>

                                </ButtonGroup>

                            </FormControl>     

                        )}

                </Formik>

            </Box>

      </TransitionsModal>
      
    );

};

export default EvaluateServiceRequest;